// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1AxWl","selected":"Chip_selected__1wgpz"};